module.exports = __webpack_public_path__ + "static/media/abihome-logo.a6156214.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/abihome-logo.svg
// module id = 416
// module chunks = 17